export default {
  total: 100,
  loaded: 0,
  text: '',
  name: '',
  description: '',
}
